<template>
  <div class="container" :class="{'container_qr': isQrOnlyMode, 'container_remark': isMobileRemarkCompact}">
    <img class="container_header_right_img" src="@/assets/m_all.png" alt="">
    <div class="container_header">
      <div class="container_header_title">Mã đặt hàng</div>
      <div class="container_header_content">
        <div class="container_header_left">
          <img class="container_header_left_img" :src="qrUrl" alt="">
        </div>
        <div class="container_header_right">
          <div @click="downloadImage(qrUrl)" class="container_header_right_btn">Lưu mã QR</div>
        </div>
      </div>
    </div>
    <template v-if="!isQrOnlyMode">
    <div class="container_dotted"></div>
      <div class="container_desc">
        "Nếu sử dụng mã QR bất tiện, vui lòng sao chép thông tin tài khoản để chuyển tiền."
      </div>
      <div class="container_info">
        <div class="container_info_item">
          <div class="container_info_title">Tên ngân hàng:</div>
          <div class="container_info_box">
            <div class="container_info_value">{{ bankName }}</div>
          </div>
        </div>
        <div class="container_info_item">
          <div class="container_info_title">Tên tài khoản:</div>
          <div class="container_info_box">
            <div class="container_info_value">{{ vaName }}</div>
          </div>
        </div>
        <div class="container_info_item">
          <div class="container_info_title">Tài Khoản:</div>
          <div class="container_info_box">
            <div class="container_info_value">{{ accountNumber }}</div>
            <div @click="onCopy(accountNumber)" class="container_info_copy">sao chép</div>
          </div>
        </div>
        <div class="container_info_item" v-if="amount">
          <div class="container_info_title">Số tiền:</div>
          <div class="container_info_box">
            <div class="container_info_value">{{ formatNumber(amount) }}</div>
            <div @click="onCopy(amount)" class="container_info_copy">sao chép</div>
          </div>
        </div>
        <div class="container_info_item" v-if="remark">
          <div class="container_info_title">Ghi chú:</div>
          <div class="container_info_box">
            <div class="container_info_value">{{ remark }}</div>
            <div @click="onCopy(remark)" class="container_info_copy">sao chép</div>
          </div>
        </div>
      </div>
      <div class="container_tips">
        <div class="container_tips_label">Những điều cần lưu ý:</div>
        <div class="container_tips_value">
          Vui lòng kiểm tra số tài khoản và tên người nhận thanh toán.
          Hệ thống sẽ tự động nạp tiền cho bạn sau khi chuyển khoản thành công.
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import indexJs from "@/mixins/index";

export default {
  name: "Moblie",
  mixins: [indexJs],
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 697px;
  min-height: 100vh;
  background: url("~@/assets/m_bgi.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;

  .container_header_right_img {
    margin-top: 10px;
    margin-left: 25px;
    width: 130px;
    height: 17px;
  }

  .container_header {
    padding-top: 10px;

    .container_header_title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 11px;
      color: #743900;
      text-align: center;
    }

    .container_header_content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 0 35px;
      margin-top: 6px;

      .container_header_left {
        width: 234px;
        height: 234px;
        background: url("~@/assets/m_qrbox.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .container_header_left_img {
          width: 200px;
          height: 200px;
        }
      }

      .container_header_right {
        width: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        .container_header_right_btn {
          margin-top: 8px;
          display: flex;
          align-items: center;
          justify-content: center;

          width: 140px;
          height: 24px;
          background: #914405;
          border-radius: 19px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #FFFFFF;
        }
      }
    }
  }

  .container_dotted {
    width: calc(100% - 70px);
    height: 1px;
    margin: 0 auto;
    margin-top: 10px;
    background: linear-gradient(to left,
        transparent 0%,
        transparent 50%,
        #875525 50%,
        #875525 100%);
    background-size: 10px 1px;
    background-repeat: repeat-x;
  }

  .container_desc {
    margin: 0 auto;
    margin-top: 10px;
    width: calc(100% - 70px);
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 11px;
    color: #743900;
  }

  .container_info {
    margin: 0 auto;
    margin-top: 8px;
    width: calc(100% - 70px);

    .container_info_item {
      margin-top: 8px;

      .container_info_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #743900;
      }

      .container_info_box {
        margin-top: 3px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .container_info_value {
          flex: 1;
          overflow-wrap: break-word;
          /* 新属性，推荐使用 */
          word-break: break-all;
          /* 在任何字符之间换行 */
          min-width: 230px;
          width: 100%;
          min-height: 28px;
          background: rgba(255, 255, 255, 0.5);
          border-radius: 28px;
          border: 1px solid #FFFFFF;
          padding: 4px 8px;
          box-sizing: border-box;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 12.5px;
          color: #FF8B00;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        .container_info_copy {
          margin-left: 10px;
          width: 64px;
          height: 28px;
          background: #914405;
          border-radius: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 11px;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      &:first-child {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 8px;

        .container_info_box {
          flex: 1;
          margin-left: 5px;
          margin-top: 0;

          .container_info_value {
            min-width: 100%;
          }
        }
      }
    }
  }

  .container_tips {
    margin: 0 auto;
    margin-top: 15px;
    width: calc(100% - 70px);

    .container_tips_label {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 11px;
      color: #743900;
    }

    .container_tips_value {
      margin-top: 6px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 11px;
      color: #FF3D3D;
      line-height: 15px;
    }

  }

  &.qr-only-mode {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0e0e0e;
    /* Dark background to mimic image link */
    height: 100vh;
    width: 100vw;
    margin: 0;
    padding: 0;
  }

  &.container_remark {
    .container_header {
      padding-top: 6px;

      .container_header_content {
        margin-top: 3px;

        .container_header_left {
          width: 210px;
          height: 210px;

          .container_header_left_img {
            width: 180px;
            height: 180px;
          }
        }
      }
    }

    .container_desc {
      margin-top: 6px;
      font-size: 10px;
    }

    .container_info {
      margin-top: 4px;

      .container_info_item {
        margin-top: 5px;

        .container_info_title {
          font-size: 11px;
        }

        .container_info_box {
          margin-top: 2px;

          .container_info_value {
            min-height: 24px;
            padding: 2px 8px;
            font-size: 11.5px;
          }

          .container_info_copy {
            height: 24px;
            font-size: 10px;
          }
        }
      }
    }

    .container_tips {
      margin-top: 8px;

      .container_tips_label,
      .container_tips_value {
        font-size: 10px;
      }

      .container_tips_value {
        margin-top: 3px;
        line-height: 13px;
      }
    }
  }
}

.container_qr{
  display: flex;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
}

.qr-code-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .container_header_left_img {
    // If you want the image to be larger or original size, adjust here
    // For now, removing specific dimensions to let it be natural or max-width
    width: 100%;
    height: 100%;
    object-fit: contain; // Ensure square aspect ratio is maintained
  }
}
</style>
